import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme.ts';
import { Flex, Text } from '@mantine/core';
import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';

type Variant = 'success' | 'error' | 'regular';

const VARIANTS_SETTINGS: Record<Variant, { icon: PredefinedIcons; color: string }> = {
	success: {
		icon: 'success-checkmark-circle',
		color: defaultTheme.v3.colors.green[2],
	},
	error: {
		icon: 'error-alert-triangle',
		color: defaultTheme.v3.colors.red[2],
	},
	regular: {
		icon: 'regular-info-circle',
		color: defaultTheme.v3.colors.gray[2],
	},
};

export interface Props {
	title?: string;
	description?: string;
	variant?: Variant;
	rightSection?: React.ReactNode;
	style?: CSSProperties;
}

export const InlineNotification = ({
	title,
	description,
	variant = 'regular',
	rightSection,
	style = {},
}: Props) => {
	const settings = VARIANTS_SETTINGS[variant];

	return (
		<Box style={{ borderColor: settings.color, ...style }}>
			<Flex gap="1rem">
				<Icon size="2.5rem" variant={settings.icon} />

				<Flex direction="column" gap="0.125rem">
					{!!title && <Text size="B6Bold">{title}</Text>}
					{!!description && <Text size="B6Medium">{description}</Text>}
				</Flex>
			</Flex>

			{rightSection}
		</Box>
	);
};

const Box = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	gap: 1rem;
	padding: 0.75rem;
	border: 1px solid;
	border-radius: 0.5rem;
	background-color: ${({ theme }) => theme.v3.colors.white[0]};
`;
